import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

const provisionDefaultKey = gql<
  GraphQLTypes.ProvisionDefaultKey,
  GraphQLTypes.ProvisionDefaultKeyVariables
>`
  mutation ProvisionDefaultKey {
    me {
      ... on UserMutation {
        user {
          id
        }
        provisionKey {
          apiKey {
            id
            keyName
            token
          }
          created
        }
      }
    }
  }
`;

export const useProvisionDefaultUserToken = () => {
  const [
    finalizeProvisionKey,
    {
      data: provisionKeyData,
      error: provisionKeyError,
      loading: isProvisionKeyLoading,
      called: isProvisionKeyCalled,
    },
  ] = useMutation(provisionDefaultKey, {});

  useEffect(() => {
    finalizeProvisionKey();
  }, [finalizeProvisionKey]);

  if (provisionKeyError) {
    throw new Error(provisionKeyError.message);
  }

  const userToken =
    provisionKeyData?.me?.__typename === 'UserMutation'
      ? provisionKeyData?.me?.provisionKey?.apiKey?.token
      : '';

  return {
    finalizeProvisionKey,
    provisionKeyData,
    provisionKeyError,
    isProvisionKeyLoading,
    isProvisionKeyCalled,
    userToken,
  };
};
